import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Router, RouterModule } from '@angular/router';
import { SettingsService } from '../settings/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';


@Component({
  selector: 'app-forgot-password',
  standalone:true,
  imports:[ReactiveFormsModule, FormsModule, CommonModule, MaterialModule, RouterModule],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.less']
})
export class ForgotPasswordComponent implements OnInit {

  valForm: FormGroup;
  errorMsg: string = "";
  show_spinner:boolean=false;

  constructor(fb: FormBuilder, public snackBar: MatSnackBar, public settings: SettingsService, private router: Router, private change:ChangeDetectorRef) {

    this.valForm = fb.group({
      'email': ['', Validators.compose([Validators.required, CustomValidators.email])],
    });

  }

  randomImage: string = '';
  private images: string[] = [
    '../../assets/images/33.jpg',
    '../../assets/images/3.jpg',
    '../../assets/images/4.jpg',
    '../../assets/images/7.jpg',
    '../../assets/images/9.jpg',
    '../../assets/images/12.jpg',
    '../../assets/images/14.jpg',
    '../../assets/images/17.jpg',
    '../../assets/images/23.jpg',
    '../../assets/images/2.jpg',
    '../../assets/images/15.jpg',
    '../../assets/images/26.jpg',
  ];

  ngOnInit() {

    this.setRandomBackground();

  }

  setRandomBackground(): void {
    const randomIndex = Math.floor(Math.random() * this.images.length);
    this.randomImage = this.images[randomIndex];
  }
  
  ngAfterViewChecked() {

  }

  async submitForm($ev: any, value: any) {
    $ev.preventDefault();
    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }

    value['isInversionista'] = true;

    if (this.valForm.valid) {
      try {
        this.show_spinner = true;
        const bd: any = await this.settings.get_query(3, '/cliente-inversionista/forgot-password/', value, true);
        var body_data: any =bd._body;
        switch (bd.status) {
          case 200:
            this.show_spinner = false;
            this.snackBar.open("Hemos enviado un enlace de recuperación a tu correo. Tendrás 15 min para acceder a él, antes de que caduque.", "Aceptar", {
              panelClass: "simpli-snack",
              duration: 10000
            });            
            this.router.navigate(['/login']);
          break;
          default:
            this.show_spinner = false;
          break;
        }
  
      } catch (bd: any) {
        this.show_spinner = false;
        switch (bd.status) {
          case 400:
            this.valForm.controls['email'].setErrors({invalid: true});
            this.errorMsg = "Hemos enviado un enlace de recuperación a tu correo. Tendrás 15 min para acceder a él, antes de que caduque."
          break;
          case 404:
            this.valForm.controls['email'].setErrors({invalid: true});
            this.errorMsg = "El correo electrónico ingresado no está registrado"
          break;
          case 500:
            this.snackBar.open("Ocurrió un error, intenta de nuevo", "Aceptar", {
              duration: 20000,
              panelClass: "simpli-snack"
            });
            this.settings.send_mail_500("Recuperar contraseña", bd);
          break;
          default:
            
          break;
        }
      }
    }
  }

}
